<template>
  <a-form-model-item :label="field.label" :label-col="fieldLabelCol" :wrapper-col="fieldWrapperCol">
    <!-- 标题 -->
    <a-input v-if="field.key === 'title'" :value="form.title" allow-clear placeholder="故障标题" @change="handleInputChange('title', $event)" />
    <!-- 业务域 -->
    <a-select v-else-if="field.key === 'domains'" :value="form.domains" mode="multiple" allow-clear placeholder="故障业务域" @change="handleSelectChange('domains', $event)">
      <a-select-option v-for="(item, index) in options.domainData" :key="index" :value="item.id">
        {{ item.name }}
      </a-select-option>
    </a-select>
    <!-- 等级 -->
    <a-select v-else-if="field.key === 'level'" :value="form.level" mode="multiple" allow-clear placeholder="故障等级" @change="handleSelectChange('level', $event)">
      <a-select-option v-for="(item, index) in options.faultLevels" :key="index" :value="item.value">
        <a-tag :color="item.color">{{ item.label }}</a-tag>
      </a-select-option>
    </a-select>
    <!-- 标签 -->
    <a-select v-else-if="field.key === 'tags'" :value="form.tags" mode="multiple" allow-clear placeholder="故障标签" @change="handleSelectChange('tags', $event)">
      <a-select-option v-for="(item, index) in options.tagData" :key="index" :value="item.id">
        {{ item.name }}
      </a-select-option>
    </a-select>
    <!-- 项目 -->
    <a-select v-else-if="field.key === 'projects'" :value="form.projects" mode="multiple" allow-clear placeholder="关联项目" @change="handleSelectChange('projects', $event)">
      <a-select-option v-for="(item, index) in options.projects" :key="index" :value="item.id">{{ item.name }}</a-select-option>
    </a-select>
    <!-- 时间筛选 -->
    <a-input-group v-else-if="field.key === 'dateRange'" compact>
      <a-select :value="form.time_field" style="width: 30%" @change="handleSelectChange('time_field', $event)">
        <a-select-option value="reported_time">上报时间</a-select-option>
        <a-select-option value="created_time">创建时间</a-select-option>
      </a-select>
      <a-date-picker :value="form.begin_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleDateChange('begin_time', $event)" />
      <a-date-picker :value="form.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleDateChange('end_time', $event)" />
    </a-input-group>
    <!-- 复盘状态 -->
    <a-select v-else-if="field.key === 'recap_status'" mode="multiple" :value="form.recap_status" allow-clear placeholder="复盘状态" @change="handleSelectChange('recap_status', $event)">
      <a-select-option v-for="(item, index) in options.faultRecapStatus" :key="index" :value="item.value">
        <a-tag :color="item.color">{{ item.label }}</a-tag>
      </a-select-option>
    </a-select>
  </a-form-model-item>
</template>

<script>
export default {
  name: 'FaultFilterFormItem',
  props: {
    field: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true,
      default: () => ({
        faultLevels: [],
        faultRecapStatus: [],
        domainData: [],
        tagData: [],
        projects: []
      })
    },
    reset: {
      type: Boolean,
      default: false
    },
    labelCol: {
      type: Object,
      default: null
    },
    wrapperCol: {
      type: Object,
      default: null
    }
  },
  computed: {
    fieldLabelCol() {
      return this.labelCol === null ? { span: this.field.labelSpan || 6 } : this.labelCol;
    },
    fieldWrapperCol() {
      return this.wrapperCol === null ? { span: this.field.wrapperSpan || 18 } : this.wrapperCol;
    }
  },
  methods: {
    handleInputChange(key, event) {
      this.$emit('change', { key, value: event.target.value });
    },

    handleSelectChange(key, value) {
      this.$emit('change', { key, value });
    },

    handleDateChange(key, value) {
      this.$emit('change', { key, value });
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 0px;

  .ant-form-item-label {
    text-align: right;
    color: #495057;
    padding-right: 8px;
  }
}

:deep(.ant-input),
:deep(.ant-select),
:deep(.ant-picker),
:deep(.ant-tree-select),
:deep(.ant-input-group),
:deep(.ant-calendar-picker) {
  width: 100%;
}
</style>
